import e from '@unseenco/e'
const evt = new e()

export default evt